<template>
  <div>
    <div id="feedpost-view" class="modal fade">
      <div class="modal-dialog feedpost-ensize" :style="{ 'max-width': viewData.sgL_Type == 2?'500px': '1280px' }">
        <div id="feedback_frame_aj" class="modal-content" v-if="viewData != null">
          <div id="feedback_photo_aj" class="col-8" v-if="viewData.sgL_Type !== 2">
            <div class="feedpost-main-content">
            <a v-if="viewData.sgL_GroupId"
              class="navigate-target navigate-prev"
              href="javascript:void(0);"
              @click="change(-1)"
              :title="$t('Album.photoview.Lastpage')"
              ><i class="fa fa-chevron-left fa-2x"></i
            ></a>
            <a v-if="viewData.sgL_GroupId"
              class="navigate-target navigate-next"
              href="javascript:void(0);"
              @click="change(1)"
              :title="$t('Album.photoview.nextpage')"
              ><i class="fa fa-chevron-right fa-2x"></i
            ></a>
              <img ref="imgs" style="max-width:600px" v-if="viewData.sgL_Type == 1" :src="viewData.sgL_GroupId ? viewData.sgL_GroupImageTemplP[0] :viewData.sgL_ImageTempURL" />
              <video-player v-else class="video-player vjs-custom-skin" :playsinline="true" :options="playerOption"
                @play="onPlayerPlay($event, viewData.id)"></video-player>
            </div>
          </div>
          <div id="feedback_content_aj" :class="{ 'col-4':viewData.sgL_Type !== 2, 'col-12':viewData.sgL_Type == 2}">
            <div class="feedpost-sub-content">
              <div class="feedpost-head">
                <div class="feedpost-user mr-2">
                  <a href="javascript:void(0);">
                    <img class="user-logo mr-2" :src="viewData.userLogoBig" :onerror="$defaultUserLog" /></a>
                  <span class="feedpost-username">
                    {{ viewData.sgL_UsersName }}
                  </span>
                  <span class="publish-time">{{
                    viewData.sgL_PG_CAddTimerI
                  }}</span>
                </div>
                <div class="feedpost-more">
                  <i class="fa fa-ellipsis-h"></i>
                  <div class="feedpost-menus">
                    <a href="javascript:void(0);" @click="collectFunc(viewData)">
                      <li class="bookmark">
                        <i class="fas fa-bookmark fa-fw" v-if="viewData.sgL_IsFavorite"></i>
                        <i v-else class="far fa-bookmark mr-1"></i>  {{ $t('Social.DataView.bookmark') }}
                      </li>
                    </a>
                    <a href="javascript:void(0);" @click="reportFunc(viewData)">
                      <li class="report">
                        <i v-if="viewData.sgL_IsImpeach" class="fa fa-flag mr-1"></i>
                        <i v-else class="far fa-flag mr-1"></i>  {{ $t('Social.DataView.flag') }}
                      </li>
                    </a>
                    <a href="javascript:void(0);" @click="deleteFunc(viewData)" v-if="
                      loginUser != null &&
                      viewData.sgL_UserID == loginUser.userId
                    ">
                      <li class="delete">
                        <i class="far fa-trash-alt mr-1"></i>  {{ $t('Social.DataView.delbolg') }}
                      </li>
                    </a>
                  </div>
                </div>
              </div>
              <div class="feedpost-scroll">
                <div class="feedpost-content2">
                  <p>{{ viewData.sgL_Content }}</p>
                </div>
                <div class="feedpost-bottom">
                  <ul class="feedpost-action">
                    <a href="javascript:void(0);" @click="likeFunc(viewData, viewData.sgL_IsLike)">
                      <li class="like" v-if="viewData.sgL_IsLike">
                        <i class="fas fa-thumbs-up mr-1" v-if="viewData.sgL_PG_CTotalLike == 0">
                           {{ $t('Social.DataView.thumbs') }}</i>
                        <i class="fas fa-thumbs-up mr-1" v-else>
                          {{ viewData.sgL_PG_CTotalLike }}</i>
                      </li>
                      <li class="like" v-else>
                        <i class="far fa-thumbs-up mr-1" v-if="viewData.sgL_PG_CTotalLike == 0">
                           {{ $t('Social.DataView.thumbs') }}</i>
                        <i class="far fa-thumbs-up mr-1" v-else>
                          {{ viewData.sgL_PG_CTotalLike }}</i>
                      </li>
                    </a>
                    <a href="javascript:void(0);" style="color: #292c32" @click="updateStatistics(viewData, 50)">
                      <li class="share right">
                        <i v-if="viewData.sgL_PG_CTotalShare == 0" class="fa fa-share mr-1"> {{ $t('Social.DataView.share') }}</i>
                        <i v-else class="fa fa-share mr-1">
                          {{ viewData.sgL_PG_CTotalShare }}</i>
                      </li>
                    </a>
                  </ul>
                  <div class="feedpost-comment">
                    <div class="feedpost-comment-list">
                      <div class="comment" v-for="comment in commentList" :key="comment.id">
                        <div class="comment-left mr-2">
                          <a href="javascript:void(0);">
                            <img class="user-logo" :src="comment.sgL_ImageLogin" :onerror="$defaultUserLog" />
                          </a>
                        </div>
                        <div class="comment-right">
                          <span class="feedpost-user">
                            {{ comment.sgL_Mem_DisplayName }}
                          </span>
                          <span class="comment-content">
                            {{ comment.sgL_Msg_MContent }}
                          </span>
                          <span class="publish-time">
                            {{ comment.sgL_Msg_MAddTimerI }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <input class="form-control" type="text" :placeholder="$t('Social.DataView.placeholder')" v-model="commentText"
                @keydown="key($event, viewData)" />
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      viewData: {},
      commentList: {},
      ImgIndex: 0 ,
      commentText: "",
      playerOption: {
        playbackRates: [0.5, 1, 2, 3], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src: "",
          },
        ],
        poster: "",
        notSupportedMessage: "此視頻暫無法播放，請稍後再試",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true,
        },
      },
    };
  },
  methods: {
    playerReadied(player) {
      player.currentTime(0);
    },
    onPlayerPlay(player, index) {
      this.$emit("onPlayerPlay", player, index);
    },
    updateStatistics(item, type) {
      this.$emit("updateStatistics", item, type);
    },
    likeFunc(item, isadd) {
      this.$emit("likeFunc", item, isadd);
    },
    collectFunc(item) {
      this.$emit("collectFunc", item);
    },
    reportFunc(item) {
      this.$emit("reportFunc", item);
    },
    deleteFunc(item) {
      this.$emit("deleteFunc", item);
    },
    key(event, item) {
      this.$emit("key", event, item, this.commentText);
    },
    clearCommentText() {
      this.commentText = "";
    },
    clear() {
      this.viewData = {};
      this.commentList = {};
      this.commentText = "";
    },
    dialogClose() {
      let _this = this;
      $("#feedpost-view").on("hide.bs.modal", function () {
        _this.setPlayerOptionToUrl("");
      });
    },
    hideWindow() {
      $("#feedpost-view").modal("hide");
      this.$emit("hide");
    },
    showWindow() {
      $("#feedpost-view").modal("show");
      this.$emit("show");
    },
    setData(data) {
      this.viewData = data;
    },
    setcommentData(commentList) {
      this.commentText = "";
      this.commentList = commentList;
    },
    setPlayerOption(url) {
      //this.playerOption.sources[0].src = url;
      this.playerOption = url;
    },
    setPlayerOptionToUrl(url, poster) {
      this.playerOption.sources[0].src = url;
      if (!this.IsNullOrEmpty(poster)) {
        this.playerOption.poster = poster;
      }
    },
    change(index){
      var len = this.ImgIndex + index;
      if(len < 0 ){
        return;
      }else if(len < this.viewData.sgL_GroupImageTemplP.length){
        this.ImgIndex = len;
      }else{
        return;
      }
      this.$refs.imgs.src = this.viewData.sgL_GroupImageTemplP[this.ImgIndex];
    }
  },
  mounted() {
    this.dialogClose();
  },
};
</script>

<style scoped>
.feedpost-main-content .video-player {
  width: 100%;
  height: 100%;
}
.feedpost-comment-list {
    max-height: 50vh;
    overflow: auto;
}

</style>


// WEBPACK FOOTER //
// src/components/Social/DataView.vue